import React from "react";
import "../Styling/FormInput.css";

const FormInput = ({
  label,
  type = "text",
  name,
  value,
  onChange,
  placeholder,
 options = [],

}) => {
  return (
    <div className="form-group">
      {label && (
        <label htmlFor={name} className="form-label">
             {label} 
        </label>
      )}
 
       {type === "select" ? (
        <select
          id={name}
          name={name}
          value={value || ""}
          onChange={onChange}
          className={`form-control`}
        >
          <option value="">Select {label}</option>
          {options.map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
        </select>
      ) : (
      <input
        type={type}
        id={name}
        name={name}
        value={value || ""}     
        onChange={onChange}
        placeholder={placeholder}
        className={`form-control`}
      />

    )}
      
    </div>
  );
};

export default FormInput;